/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IGlucoUser } from 'app/shared/model/gluco-user.model';

export interface INipsScore {
  id?: string;
  facialExpression?: number;
  cry?: number;
  breathingPatterns?: number;
  arms?: number;
  legs?: number;
  stateOfArousal?: number;
  active?: boolean;
  timestampentry?: number;
  microSec?: number;
  lastupdated?: number;
  cursor?: number;
  patient?: IGlucoUser;
}

export const defaultValue: Readonly<INipsScore> = {
  active: false,
};
